
import { register } from 'register-service-worker'
import  store from './store/index'
const isElectron = typeof navigator !== 'undefined' && /Electron/i.test(navigator.userAgent || '');
const isFileProtocol = typeof window !== 'undefined' && window.location && window.location.protocol === 'file:';
const shouldRegisterServiceWorkers = process.env.NODE_ENV === 'production' && !isElectron && !isFileProtocol;

if (shouldRegisterServiceWorkers) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
   
    },
    registered () {

    },
    cached () {

    },
    updatefound () {

    },
    updated () {
    },
    offline () {
    },
    error (error) {
    }
  });
  register(`/OneSignalSDKWorker.js`);
}
